/* eslint-disable jsx-a11y/anchor-is-valid */

import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";

import { Redirect, Switch } from "react-router-dom";

import { ContentRoute } from "../../../../_metronic/layout";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import ChangePassword from "./ChangePassword";
import Login from "./Login";
import React from "react";
import Registration from "./Registration";

// import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export function AuthPage() {
  return (
    <>
      <Switch>
        <ContentRoute path="/auth/login" component={Login} />
        <ContentRoute path="/auth/registration" component={Registration} />
        <ContentRoute path="/auth/reset-password/:token" component={ResetPassword} />
        <ContentRoute path="/auth/forgot-password" component={ForgotPassword} />
        <ContentRoute path="/auth/change-password" component={ChangePassword} />
        <Redirect from="/auth" exact={true} to="/auth/login" />
        <Redirect to="/auth/login" />
      </Switch>
    </>
  );
}
